import React, { FunctionComponent, useEffect } from 'react';
import { useAutomations } from '../use-automations';

export const AutomationNew: FunctionComponent = () => {
  const { createAutomation } = useAutomations();

  useEffect(() => {
    createAutomation('empty_automation', undefined);
  }, []);

  return <></>;
};
